module.exports = __webpack_public_path__ + "img/screenshot_board_4_super_color.056426e5.png";